module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-01-en.f1f71d0fcab2d2074dfe59197660405a.png";